import {
	type ISSUE_ASSIGNED_EVENT,
	type ISSUE_CREATED_EVENT,
	type ISSUE_DELETED_EVENT,
	type ISSUE_TRANSITIONED_EVENT,
	type ISSUE_UPDATED_EVENT,
	type ISSUE_COMMENTED_EVENT,
	type ISSUE_PARENT_ASSOCIATION_EVENT,
	type BOARD_SCOPE_ISSUES_UPDATED,
	SUBSCRIPTION_SUPPORTED_EVENTS,
} from '../constants/events.tsx';

import type { EventPayload, IssueEventPayload } from './payloads.tsx';

export type IssueAssignedEvent = {
	type: typeof ISSUE_ASSIGNED_EVENT;
	payload: IssueEventPayload;
};

export type IssueCreatedEvent = {
	type: typeof ISSUE_CREATED_EVENT;
	payload: IssueEventPayload;
};

export type IssueDeletedEvent = {
	type: typeof ISSUE_DELETED_EVENT;
	payload: IssueEventPayload;
};

export type IssueTransitionedEvent = {
	type: typeof ISSUE_TRANSITIONED_EVENT;
	payload: IssueEventPayload;
};

export type IssueUpdatedEvent = {
	type: typeof ISSUE_UPDATED_EVENT;
	payload: IssueEventPayload;
};

export type IssueCommentedEvent = {
	type: typeof ISSUE_COMMENTED_EVENT;
	payload: IssueEventPayload;
};

export type RealtimeEventType =
	| typeof ISSUE_ASSIGNED_EVENT
	| typeof ISSUE_CREATED_EVENT
	| typeof ISSUE_DELETED_EVENT
	| typeof ISSUE_TRANSITIONED_EVENT
	| typeof ISSUE_UPDATED_EVENT
	| typeof ISSUE_COMMENTED_EVENT
	| typeof ISSUE_PARENT_ASSOCIATION_EVENT
	| typeof BOARD_SCOPE_ISSUES_UPDATED;

export type RealtimeEvent = {
	type: RealtimeEventType;
	payload: EventPayload;
};

export function isSubscriptionEventType(type: unknown): type is RealtimeEventType {
	return typeof type === 'string' && SUBSCRIPTION_SUPPORTED_EVENTS.has(type);
}
